<!-- Объединённые ячейки -->
<ng-container *ngIf="column !== null">
    <ng-container *ngIf="column.is_group; else single">
        <ng-container *ngIf="!!column.columns?.length">
            <ng-container *ngFor="let unionColumn of getNotNullColumns(column.columns); let isLast = last">
                <!-- Ячейка -->
                <ng-container
                    [ngTemplateOutlet]="cellSwitch"
                    [ngTemplateOutletContext]="{ column: unionColumn, row }"
                ></ng-container>

                <!-- Разделитель ячеек для числового типа -->
                <ng-container *ngIf="(unionColumn.type === 'float' || unionColumn.type === 'integer') && !isLast">
                    |
                </ng-container>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="!column.columns?.length">
            <ng-container [ngTemplateOutlet]="cellSwitch" [ngTemplateOutletContext]="{ column, row }"></ng-container>
        </ng-container>
    </ng-container>
</ng-container>

<!-- Обычные ячейки -->
<ng-template #single>
    <ng-container [ngTemplateOutlet]="cellSwitch" [ngTemplateOutletContext]="{ column, row }"></ng-container>
</ng-template>

<!-- Выбор компонента для ячейки -->
<ng-template #cellSwitch let-column="column" let-row="row">
    <ng-container [ngSwitch]="columnType">
        <ng-container *ngSwitchCase="'htmltexttype'">
            <app-html-cell [column]="column" [row]="row"></app-html-cell>
        </ng-container>

        <ng-container *ngSwitchCase="'reestr'">
            <app-html-cell [column]="column" [row]="row"></app-html-cell>
        </ng-container>

        <ng-container *ngSwitchCase="'link'">
            <app-link-cell [column]="column" [row]="row"></app-link-cell>
        </ng-container>

        <ng-container *ngSwitchCase="'gallery'">
            <app-gallery-cell [column]="column" [row]="row"></app-gallery-cell>
        </ng-container>

        <ng-container *ngSwitchCase="'file'">
            <app-file-cell [column]="column" [row]="row"></app-file-cell>
        </ng-container>

        <ng-container *ngSwitchCase="'file_versions'">
            <app-file-cell [column]="column" [row]="row"></app-file-cell>
        </ng-container>

        <ng-container *ngSwitchCase="'color'">
            <app-color-cell [column]="column" [row]="row"></app-color-cell>
        </ng-container>

        <ng-container *ngSwitchCase="'list'">
            <app-table-cell-list [column]="column" [row]="row"></app-table-cell-list>
        </ng-container>

        <ng-container *ngSwitchCase="'float'">
            <app-float-cell [column]="column" [row]="row"></app-float-cell>
        </ng-container>

        <ng-container *ngSwitchCase="'integer'">
            <app-integer-cell [column]="column" [row]="row"></app-integer-cell>
        </ng-container>

        <ng-container *ngSwitchCase="'text'">
            <app-text-cell [column]="column" [row]="row"></app-text-cell>
        </ng-container>

        <ng-container *ngSwitchCase="'boolean'">
            <app-bool-cell [column]="column" [row]="row"></app-bool-cell>
        </ng-container>

        <ng-container *ngSwitchCase="'date'">
            <app-datetime-cell [column]="column" [row]="row"></app-datetime-cell>
        </ng-container>

        <ng-container *ngSwitchCase="'datetime'">
            <app-datetime-cell [column]="column" [row]="row"></app-datetime-cell>
        </ng-container>

        <ng-container *ngSwitchDefault>
            <app-base-cell [column]="column" [row]="row"></app-base-cell>
        </ng-container>
    </ng-container>
</ng-template>
